import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
import camelcaseKeys from "camelcase-keys";

export const GET_APP_INIT_DETAILS_MESSAGE_TYPE = "get_app_init_details";

export interface BrandingInfo {
  brandingLogo: string;
  brandingName: string;
  brandingMessage: string;
  brandingLogoAltText: string;
}
export interface AppInitDetails {
  brandingInfo?: BrandingInfo;
}

export const getAppInitDetails = (): Promise<AppInitDetails> =>
  SocketAsFetch.fetch({
    message_type: GET_APP_INIT_DETAILS_MESSAGE_TYPE,
    info: {
      platform: "web",
    },
  }).then((data: any) => camelcaseKeys(data, { deep: true }));
